import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navigace.css';
import logo from '../../assets/logo.png';
import Home from '../../icons/Home';
import Hamburger from '../../icons/Hamburger';

const Navigace = () => {
    const [isNavExpanded, setIsNavExpanded] = useState(false)

    return (
        <div className="topnav" id="myTopnav">
            <div className='leftSide'>
                <img src={logo} alt='logo' />
            </div>
            <button
                className="hamburger"
                onClick={() => {
                    setIsNavExpanded(!isNavExpanded)
                }}
            >
                <Hamburger />
            </button>
            <div className={isNavExpanded ? 'rightSide expanded' : 'rightSide'}>
                <NavLink to='/' className="alink" onClick={() => setIsNavExpanded(false)}>
                    <Home />
                </NavLink>
                <NavLink to='/rrzj' className="alink" onClick={() => setIsNavExpanded(false)}>
                    Referenční rámec
                </NavLink>
                <NavLink to='/popisy' className="alink" onClick={() => setIsNavExpanded(false)}>
                    Popisy ČZJ
                </NavLink>
                <NavLink to='/glosar' className="alink" onClick={() => setIsNavExpanded(false)}>
                    Glosář
                </NavLink>
                <NavLink to='/vyhledavani' className="alink" onClick={() => setIsNavExpanded(false)}>
                    Vyhledávání
                </NavLink>
                <NavLink to='/proverejnost' className="alink" onClick={() => setIsNavExpanded(false)}>
                    Pro veřejnost
                </NavLink>
                <NavLink to='/download' className="alink" onClick={() => setIsNavExpanded(false)}>
                    Ke stažení
                </NavLink>
                <NavLink to='/enis' className="alink" onClick={() => setIsNavExpanded(false)}>
                    EN/IS
                </NavLink>
            </div>
        </div>
    )
}

export default Navigace;
